import Link from 'next/link';

import { storyblokLink } from '@/helpers/storyblokLink';

function NavUtility({ navigation }) {
  return (
    <div className="hidden items-center justify-end gap-2 lg:flex">
      {navigation.map((item) => (
        <div key={item._uid} className="relative">
          <Link
            href={storyblokLink(item.page)}
            className="inline-block whitespace-nowrap px-2 font-heading text-sm font-normal transition duration-700 ease-in-out hover:text-theme-red hover:duration-200"
          >
            <>{item?.label ? item.label : item.name}</>
          </Link>
        </div>
      ))}
    </div>
  );
}
export default NavUtility;
